import React from "react";
import { Phone, Mail, User, Edit3 } from "react-feather";

// Each role keeps one colour everywhere (badges, stats, section heads).
export const ROLE_TONES = {
  Admin: "sky",
  Accounts: "butter",
  Officer: "mint",
  Employee: "peach",
  Partner: "lilac",
};

export const ROLE_ORDER = ["Admin", "Accounts", "Officer", "Employee", "Partner"];

export const roleTone = (role) => ROLE_TONES[role] || "ink";

// Admins without an activeStatus have always counted as active.
export const isActiveAdmin = (admin) =>
  !admin.activeStatus || admin.activeStatus === "Active";

const initialOf = (name) => {
  const c = String(name || "").trim().charAt(0);
  return /[A-Za-zঀ-৿]/.test(c) ? c.toUpperCase() : null;
};

// A staff ID card on a lanyard (styles: .kd-badge* in admins-kido.css).
// Without `onChange` it renders as a static preview (register page).
const AdminBadge = ({ admin, onChange, canChange = true, preview = false, index = 0 }) => {
  const tone = roleTone(admin.status);
  const active = isActiveAdmin(admin);
  const name = admin.name || (preview ? "New admin" : "—");
  return (
    <div
      className={
        `kd-badge kd-st--${tone}` +
        (active ? "" : " is-inactive") +
        (preview ? " is-preview" : "")
      }
      style={{ "--i": Math.min(index, 12) }}
    >
      <span className="kd-badge-strap" aria-hidden="true" />
      <span className="kd-badge-clip" aria-hidden="true" />
      <div className="kd-badge-card">
        <span className="kd-badge-slot" aria-hidden="true" />
        <div className="kd-badge-band">
          <span className="kd-badge-role">{admin.status || "No role"}</span>
          <span className={`kd-badge-state kd-st--${active ? "mint" : "rose"}`}>
            <span className="kd-status-dot" />
            {active ? "Active" : "Inactive"}
          </span>
        </div>
        <span className="kd-badge-photo" aria-hidden="true">
          {initialOf(admin.name) || <User size={26} />}
        </span>
        <span className="kd-badge-name" title={name}>{name}</span>
        <span className="kd-badge-lines">
          <span>
            <Phone size={12} aria-hidden="true" />
            {admin.mobileNo || "No mobile"}
          </span>
          <span title={admin.email || ""}>
            <Mail size={12} aria-hidden="true" />
            {admin.email || "No email"}
          </span>
        </span>
        {onChange && (
          <button
            type="button"
            className="kd-badge-action"
            disabled={!canChange}
            title={canChange ? "" : "Partners can't change admin status"}
            onClick={() => onChange(admin)}
          >
            <Edit3 size={13} aria-hidden="true" />
            Change status
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminBadge;
